import { useEffect, useState } from 'react';
import { autorun } from 'mobx';
// import Account from '@/components/Account/account';
import bitplaycir from '@/assets/video/bitplaycir.mp4';
import btbg from '@/assets/btbg.png';

import speaker from '@/assets/icon/speaker.png';
import medium from '@/assets/icon/medium.png';
import telegram from '@/assets/icon/telegram.png';
import twitter from '@/assets/icon/twitter.png';
import youtube from '@/assets/icon/youtube.png';
import wen from '@/assets/wenhaofill.png';
import eth from '@/assets/eth.png';
import userStore from '@/utils/userStore';
function AccountN() {
    const [setUser] = useState(userStore.user);
    const [isHovered, setIsHovered] = useState(false);
    useEffect(() => {
        const disposer = autorun(() => {
            console.log('User changed:', userStore.user);
            setUser(userStore.user);
        });
        return () => {
            disposer();
        };
    }, [userStore.user]);
    return (
        <div>
            <div className='lg:block hidden'>
                <div className="flex h-full flex-col items-center">
                    <div className='w-[81.25rem] h-[47.5rem] flex justify-evenly '>
                        <div>
                            {/* <img src={bitplaycir} alt="" className='w-[35rem]' /> */}
                            <video className='w-[42rem]' loop autoPlay muted>
                                <source src={bitplaycir} type="video/mp4" />
                            </video>
                        </div>
                        <div className='mt-20'>
                            <img src={btbg} alt="" className='w-[504px] rounded-[8px]' />
                            <div className='w-[324px] h-[36px] mt-9 flex justify-between'>
                                <a href="https://twitter.com/BitPlayFun" target="_blank" rel="noopener noreferrer">
                                    <img src={twitter} className='w-[36px] h-[36px]' alt="Twitter" />
                                </a>
                                <a href="https://t.me/bitplayannouncement" target="_blank" rel="noopener noreferrer">
                                    <img src={speaker} className='w-[36px] h-[36px]' alt="Speaker" />
                                </a>
                                <a href="https://t.me/bitplayfun" target="_blank" rel="noopener noreferrer">
                                    <img src={telegram} className='w-[36px] h-[36px]' alt="Telegram" />
                                </a>
                                <a href="https://medium.com/@BitPlayFun" target="_blank" rel="noopener noreferrer">
                                    <img src={medium} className='w-[36px] h-[36px]' alt="Medium" />
                                </a>
                                <a href="https://www.youtube.com/@BitPlayofficial" target="_blank" rel="noopener noreferrer">
                                    <img src={youtube} className='w-[36px] h-[36px]' alt="YouTube" />
                                </a>
                            </div>

                            <div className='mt-[19px] w-[504px]  text-[#999] text-sm font-normal'>
                                <span className='block mb-2'>
                                    Game Card is an innovative asset within BitPlay’s casual gaming platform, powered by AIGC, designed to offer players a truly unique gaming experience.
                                    These cards are more than just in-game items—they are exclusive assets owned by players within the gaming ecosystem.
                                    With distinct attributes at different levels, Game Cards unlock personalized experiences and offer the value of asset gamification.
                                </span>
                                <span className='block mb-2'>
                                    To reward our early supporters, Game Cards will unlock BitPlay Token. This initiative aims to inspire player engagement and inject fresh energy into the Web3 gaming world.
                                </span>
                                <span className='block mb-2'>
                                    Stay updated on the BitPlay Game Card Package Release by following our official announcements. We will share all the necessary details, including launch dates, purchase processes, and special offers.
                                </span>
                            </div>
                            <div className="w-full h-[61px] bg-[#141420] border border-[#2b2b36] mt-9 rounded-[8px] p-5 flex justify-between relative">
                                <p className="text-[#999999] text-sm flex">
                                    Networks
                                    <img
                                        src={wen}
                                        alt=""
                                        className="w-5 h-5 ml-1.5 cursor-pointer"
                                        onMouseEnter={() => setIsHovered(true)}  // 鼠标进入图标时
                                        onMouseLeave={() => setIsHovered(false)}  // 鼠标离开图标时
                                    />
                                    <div
                                        className={`w-full h-[54px] absolute top-[-72px] left-0 mb-2 px-4 py-2 bg-[#141420] text-[#999999] text-sm rounded-lg shadow-lg flex justify-center items-center transition-all duration-500 ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-10px]'} shadow-white/15`}
                                    >
                                        Available networks in this token sale. Switch network via the wallet to participate.
                                        <div className="w-3 h-3 rotate-45 bg-[#141420] absolute left-[6.1rem] bottom-[-5px] transform -translate-x-1/2"></div>
                                    </div>
                                </p>
                                <img src={eth} alt="" className="w-5 h-5" />
                            </div>


                        </div>
                    </div>
                    {/* <div className='flex'>
                <div className="w-[58.25rem] h-[47.5rem] rounded-lg border border-[#2c2c3d] flex p-4">
                    <div>
                        <div className="grid grid-cols-2 gap-x-16 gap-y-6">
                            <div className="space-y-[10px]">
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                            </div>

                            <div className="space-y-[10px]">
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                                <div className="w-[141.42px] h-[136.66px] bg-gray-500 rounded-lg"></div>
                            </div>
                        </div>



                    </div>
                    <div className='w-full h-full  ml-6 '>
                        right
                    </div>
                </div>
                <div className="w-[375px] h-[47.5rem]  ml-2 rounded-lg border border-[#2c2c3d] p-8">
                    <Account />
                </div>
            </div> */}

                </div>
            </div>
            <div className='lg:hidden block'>
                <div>
                    <video className='w-[35rem]' loop autoPlay muted>
                        <source src={bitplaycir} type="video/mp4" />
                    </video>
                </div>
                <div className='flex flex-col items-center'>
                    <img src={btbg} alt="" className='w-[504px]' />
                    <div className='w-full flex  justify-between pl-2 pr-3 mt-2'>
                        <a href="https://twitter.com/BitPlayFun" target="_blank" rel="noopener noreferrer">
                            <img src={twitter} className='w-[36px] h-[36px]' alt="Twitter" />
                        </a>
                        <a href="https://t.me/bitplayannouncement" target="_blank" rel="noopener noreferrer">
                            <img src={speaker} className='w-[36px] h-[36px]' alt="Speaker" />
                        </a>
                        <a href="https://t.me/bitplayfun" target="_blank" rel="noopener noreferrer">
                            <img src={telegram} className='w-[36px] h-[36px]' alt="Telegram" />
                        </a>
                        <a href="https://medium.com/@BitPlayFun" target="_blank" rel="noopener noreferrer">
                            <img src={medium} className='w-[36px] h-[36px]' alt="Medium" />
                        </a>
                        <a href="https://www.youtube.com/@BitPlayofficial" target="_blank" rel="noopener noreferrer">
                            <img src={youtube} className='w-[36px] h-[36px]' alt="YouTube" />
                        </a>
                    </div>
                    <div className='mt-2 text-[#999] text-sm font-normal p-3'>
                        <span className='block mb-2'>
                            Game Card is an innovative asset within BitPlay’s casual gaming platform, powered by AIGC, designed to offer players a truly unique gaming experience.
                            These cards are more than just in-game items—they are exclusive assets owned by players within the gaming ecosystem.
                            With distinct attributes at different levels, Game Cards unlock personalized experiences and offer the value of asset gamification.
                        </span>
                        <span className='block mb-2'>
                            To reward our early supporters, Game Cards will unlock BitPlay Token. This initiative aims to inspire player engagement and inject fresh energy into the Web3 gaming world.
                        </span>
                        <span className='block mb-2'>
                            Stay updated on the BitPlay Game Card Package Release by following our official announcements. We will share all the necessary details, including launch dates, purchase processes, and special offers.
                        </span>
                    </div>
                    <div className='p-3 w-full'>
                        <div className="w-full  bg-[#141420] border border-[#2b2b36] mt-2 rounded-[8px] p-5 flex justify-between relative">
                            <p className="text-[#999999] text-sm flex">
                                Networks
                                <img
                                    src={wen}
                                    alt=""
                                    className="w-5 h-5 ml-1.5 cursor-pointer"
                                    onMouseEnter={() => setIsHovered(true)}  // 鼠标进入图标时
                                    onMouseLeave={() => setIsHovered(false)}  // 鼠标离开图标时
                                />
                                <div
                                    className={`w-full h-[54px] absolute top-[-72px] left-0 mb-2 px-4 py-2 bg-[#141420] text-[#999999] text-sm rounded-lg shadow-lg flex justify-center items-center transition-all duration-500 ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[-10px]'} shadow-white/15`}
                                >
                                    Available networks in this token sale. Switch network via the wallet to participate.
                                    <div className="w-3 h-3 rotate-45 bg-[#141420] absolute left-[6.1rem] bottom-[-5px] transform -translate-x-1/2"></div>
                                </div>
                            </p>
                            <img src={eth} alt="" className="w-5 h-5" />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default AccountN;
